/**************************************************
 * Nombre:       Seccion_Campanas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_MONEDA,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOSCAMPANAS} from "../../Constantes";
import {where} from "firebase/firestore";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {usuarioContext} from "../../App";
import Dialogo_Detalle_Campana_Info from "../Dialogos/Dialogo_Detalle_Campana_Info";

const Seccion_Campanas = () => {
    const cData = useContext(usuarioContext)
    const [totalDepositos, setTotalDepositos] = useState(0);
    const [wheres, setWherees] = useState([where('idUsuario', '==', cData.usuario.id)]);
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'campanas', wheres: wheres})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Detalle_Campana_Info,
        titulo: 'Detalles Deposito',
        realizado: cargarNuevamente
    })
    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
                break
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={`Campañas Realizadas`}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        // clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        textoAgregar={'Nuevo Deposito'}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Campanas

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Numero',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombreFunnel'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA
    },
    {
        nombre: 'Pais',
        direccion: 'left',
        propiedad: 'pais',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSCAMPANAS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]